

import {mapCreator, task} from 'nanostores';
import { jsonOrFail } from './utils.jsx';
import { $productConfig } from './Config.jsx';



export const $statementStatus = mapCreator(($, id) => {
    const config = $productConfig.get();

    $.set({
        id,
        isLoaded: null,
        lastError: null,
        data: null
    });
    
    $.setKey('isLoaded', null);
    fetch(config.status_url(id), {})
    .then(jsonOrFail)
    .then((data) => {
        $.setKey('isLoaded', true);
        $.setKey('data', data)

        return data;

    }, (err) => {
        $.setKey('isLoaded', false);
        $.setKey('lastError', err);
        $.setKey('data', null);

        return err;

    });
});

export const resetStatementSalt = ($) =>
    task(async () => {
        const
            config = $productConfig.get(),
            data = $.get();

        return fetch(config.status_url(data.id) + '?act=resalt', {
            method:'POST',
        })
        .then(jsonOrFail)
    });

